import "./AppLayout.css";
import { Toolbar, Header } from "../../adminExportFiles";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  return (
    <div className="app-container">
      <Toolbar />
      <div className="main-content">
        <Header />
        <div className="content-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
